module.exports = __webpack_public_path__ + "VRApplicationn-3b94833e.webp";